// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"546":"2c65d4a2","711":"9ecc772b","727":"e5aa413f","827":"fdbc28af","856":"8c619e6f","868":"9cf209ac","913":"efe79e0d","922":"d52f8edf","927":"4f9894c8"}[chunkId] + ".js";
};